/**
 * Brand Story [New] — scroll reveal for media + press quotes
 * Timings match BrandStory.jsx (media 1.1s, image scale 2.4s, quotes 0.7s + 0.12s stagger)
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'brand-story-new';
  var instances = new WeakMap();

  function BrandStoryNew(root) {
    this.root = root;
    this.revealEls = Array.prototype.slice.call(
      root.querySelectorAll('[data-reveal]')
    );
    this.reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reducedMotion) root.classList.add('is-reduced-motion');
    this.observeReveal();
  }

  BrandStoryNew.prototype.observeReveal = function () {
    var self = this;
    if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
      this.revealEls.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
          window.setTimeout(function () {
            el.classList.add('is-inview');
          }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
    );

    this.revealEls.forEach(function (el) {
      observer.observe(el);
    });
  };

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new BrandStoryNew(root));
    });
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector
      ? section.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
      : null;
    if (!root && section.getAttribute && section.getAttribute('data-section-type') === SECTION_TYPE) {
      root = section;
    }
    if (!root) return;
    instances.delete(root);
    instances.set(root, new BrandStoryNew(root));
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) instances.delete(root);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }
})();
